<div>
  <form [formGroup]="addSecondaryPhoneForm" aria-live="polite" [attr.aria-busy]="isFormSubmit">

    <!-- Primary Phone Field -->
        <div class="fdx-c-form-group fdx-c-form-group--float-label
    fdx-c-form-group--has-value fdx-o-grid__item--11 fdx-u-ml--5 fdx-u-mt--1">
      <div class="fdx-c-form-group__item">
        <input readonly type="text" class="fdx-c-form-group__input" id="primaryPhNo"
          value="{{countryCode}} {{phoneNumber}}">
          <label class="fdx-c-form-group__label fdx-c-form-group__label--dark" for="primaryPhNo">
            {{ 'phoneNumber.primaryPhoneNumber' | translate}}
          </label>
        </div>
      </div>

      <!-- Add New Number Phone Field -->
      @if (!isAddNumber) {
        <div class="fdx-o-grid__item--12 fdx-u-align--right">
          <button id="addNewNoBtn" (click)="toggleAddNumber(true)"
            attr.aria-label=" {{'phoneNumber.addNewNumber' | translate}}"
            class="fdx-c-button fdx-c-button--text fdx-u-mb--7 fdx-u-cursor--pointer">
            {{'phoneNumber.addNewNumber' | translate}}
          </button>
        </div>
      }

      <!-- Secondary Phone Field -->
      @if (isAddNumber) {
        <div class="fdx-o-grid">
          <div data-sg="paint">
            <div
              class="fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--select fdx-o-grid__item--11 fdx-u-ml--5">
              <ciam-phone formControlName="secondaryPhone" [codeDisabled]="true" [id]="'provided-id-phone2'"
                onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                <span class="label-ctry-code">{{ 'contact.countryCodeDropdown' | translate }}</span>
                <span id="secondaryPhoneNumberLabel" class="label-number">{{
                'phoneNumber.secondaryPhoneNumberOptional' | translate}}</span>
                @if (addSecondaryPhoneForm.controls['secondaryPhone'].getError('phoneNumber')) {
                  <span
                    class="error-number">
                    @if (addSecondaryPhoneForm.controls['secondaryPhone'].getError('phoneNumberRequired')) {
                      <span
                        class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0@small">
                        <div class="fdx-c-form-message__icon">
                          <ciam-icon class="fdx-c-icon" aria-hidden="true" key="utility_cross-fat">
                          </ciam-icon>
                        </div>
                        {{'contact.phoneNumberRequired' | translate}}
                      </span>
                    }
                    @if (addSecondaryPhoneForm.controls['secondaryPhone'].getError('regionRange')) {
                      <span
                        class="fdx-c-form-message fdx-c-form-message--error fdx-u-pb--0 fdx-u-pl--0@small">
                        <div class="fdx-c-form-message__icon">
                          <ciam-icon class="fdx-c-icon" aria-hidden="true" key="utility_cross-fat">
                          </ciam-icon>
                        </div>
                        {{'contact.phoneNumberRange' | translate}}
                      </span>
                    }
                  </span>
                }
              </ciam-phone>
            </div>
          </div>
          <!-- FIXME: validationErrorList should go here -->
          <!-- Display Error Messages -->
          @for (error of validationErrorList; track error) {
            <div class="fdx-c-form-message fdx-c-form-message--error"
              id="errorMessage">
              <ciam-icon class="fdx-c-icon" aria-hidden="true" key="utility_cross-fat"></ciam-icon>
              {{error}}
            </div>
          }
          <!-- Done button -->
          <div class="fdx-u-align--center fdx-u-pt--5">
            <button aria-live="polite" [attr.aria-busy]="isFormSubmit" type="submit" id="doneBtn"
              (click)="addNewNumber()"
              class="fdx-c-button fdx-c-button--full-width fdx-c-button--primary fdx-c-button--loading fdx-c-button--responsive"
              [ngClass]="{'fdx-c-button--is-loading' : isFormSubmit}" aria-atomic="true" aria-label="Done">
              <span class="fdx-c-button__loading-container">
                <span id="doneBtn" class="fdx-c-button__title">{{ 'phoneNumber.doneBtn' | translate}}</span>
                <span class="fdx-c-button__loading">
                  <div class="fdx-c-loading-indicator  fdx-c-loading-indicator--white">
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                    <div class="fdx-c-loading-indicator__part"></div>
                  </div>
                </span>
              </span>
            </button>
          </div>
          <!-- Cancel link -->
          <div class="fdx-o-grid__item--12 fdx-u-align--center">
            <button id="cancelBtn" (click)="toggleAddNumber(false)"
              attr.aria-label="{{'login.cancelLabel' | translate}}"
              class="fdx-c-button fdx-c-button--text fdx-u-mb--7 fdx-u-cursor--pointer">
              {{'login.cancelLabel' | translate}}
            </button>
          </div>
        </div>
      }
    </form>
  </div>

  <ng-template #twoFactorElevationFailure>
    <p>{{'contact.twoFactorElevationError' | translate}}</p>
  </ng-template>